<script setup>
import { onMounted, ref, watch, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import { useAuthStore, useContractStore } from '../stores';
import AssessmentCard from './AssessmentCard.vue';
import iconArrowLeft from '~/assets/icon_arrow_left.svg'

const route = useRoute()
const authStore = useAuthStore()
const assessmentData = ref(null)
const currentChild = ref({})

const slideIndex = ref(0)
const router = useRouter()
watch(route, async (to, prev) => {
    // if (to.path.includes('readiness/assessment') && to.params.id) {
    //     await configureAssessmentData(to.params.id)
    // }
})


const configureAssessmentData = async (assessmentId) => {
    // if (!assessmentStore.readinessAssessments[assessmentId] || !assessmentStore.readinessAssessments[assessmentId].assessment_milestones) {
    //     await assessmentStore.fetchAssessmentById(assessmentId)
    // }
    // const assessmentReportCardId = assessmentStore.readinessAssessments[assessmentId].readiness_report_card_id
    // assessmentData.value = assessmentStore.readinessAssessments[assessmentId]

    // // set current child from RRC if deep linked 
    // currentChild.value = assessmentStore.readinessReportCards[assessmentReportCardId].child
}

onMounted(async () => {
    // await configureAssessmentData(route.params.id)
})

</script>
<template>
    <div class="mx-2 mt-2">
        <div class="flex flex-col justify-center content-center">
            <div class="block w-96 max-w-md bg-white  rounded-xl shadow-md flex flex-col justify-start content-center items-center mb-2 w-full">
                <div class="overflow-hidden w-full px-4" v-if="true">
                </div>
            </div>
        </div>
    </div>
</template>